// extracted by mini-css-extract-plugin
module.exports = {"socialMediaContainer":"SocialMedia_socialMediaContainer__1QiFm","socialMediaSvg":"SocialMedia_socialMediaSvg__1FqWs"};